import React, { useEffect, useRef } from 'react';
import { CalendarIcon, MailIcon, LinkedinIcon, MapPinIcon, YoutubeIcon } from 'lucide-react';
export function ContactContent() {
  const schedulerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let frame = 0;
    const scrollToScheduler = () => {
      if (window.location.hash !== '#/contact/book') return;
      frame = requestAnimationFrame(() => {
        schedulerRef.current?.scrollIntoView({
          block: 'start'
        });
      });
    };
    scrollToScheduler();
    window.addEventListener('hashchange', scrollToScheduler);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('hashchange', scrollToScheduler);
    };
  }, []);
  return <section className="w-full bg-white pt-16 md:pt-20 pb-12 md:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-7" data-mp="2gwb4w3bztedx">
      <div className="max-w-4xl mx-auto" data-id="element-8" data-mp="2bwoppoclto2h">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-brand-navy mb-10 leading-tight" data-id="element-9" data-mp="2bvncbd848phl">
          Let's talk.
        </h1>
        <p className="text-2xl md:text-3xl text-brand-gray leading-relaxed mb-12" data-id="element-10" data-mp="1tihr0l6gm16g">
          Whether you have a specific need or just want to explore how AI
          transformation could work for your team, I'd love to hear from you.
        </p>

        <div className="space-y-16" data-id="element-11" data-mp="1jlmx6fl4soyi">
          {/* Book a Call */}
          <div id="book" ref={schedulerRef} className="scroll-mt-28" data-id="element-12" data-mp="1oidboyhafcht">
            <a href="https://scheduler.zoom.us/breakapencil/intro-call-30" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-10 py-5 border border-transparent text-xl font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors shadow-sm w-full sm:w-auto" data-id="element-13" data-mp="2c8pq8s71g7hd">
              <CalendarIcon className="w-6 h-6" aria-hidden="true" data-id="element-14" data-mp="rt47lf8z99c0" />
              Book a 30-minute intro call
              <span className="sr-only" data-id="element-15" data-mp="vuzb8qedrysy">(opens in a new tab)</span>
            </a>
          </div>

          {/* Email */}
          <div className="flex items-start py-8 border-b border-gray-100" data-id="element-16" data-mp="2yfti78zu8u5s">
            <MailIcon className="w-8 h-8 text-brand-orange mr-6 mt-1 flex-shrink-0" data-id="element-17" data-mp="2thib360xgxr9" />
            <div data-id="element-18" data-mp="2or1wvjpa983u">
              <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-19" data-mp="2oqjojopcj3fk">Email</h2>
              <a href="mailto:michael@breakapencil.com" className="text-xl text-brand-gray-light hover:text-brand-orange transition-colors border-b-2 border-brand-orange/30 hover:border-brand-orange pb-1" data-id="element-20" data-mp="2jsi5v4vu164m">
                michael@breakapencil.com
              </a>
            </div>
          </div>

          {/* Connect */}
          <div className="flex items-start py-8 border-b border-gray-100" data-id="element-21" data-mp="25ujwyf0a61wi">
            <LinkedinIcon className="w-8 h-8 text-brand-orange mr-6 mt-1 flex-shrink-0" data-id="element-22" data-mp="20uxjc4gjijn6" />
            <div data-id="element-23" data-mp="3zt2jiaqzfaf">
              <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-24" data-mp="40b4mvk3cnq9">
                Connect
              </h2>
              <div className="flex flex-col sm:flex-row sm:items-center gap-6" data-id="element-25" data-mp="3v5koe5hhs5rf">
                <a href="https://www.linkedin.com/in/mhirsch/" target="_blank" rel="noopener noreferrer" className="text-xl text-brand-gray-light hover:text-brand-orange transition-colors inline-flex items-center" data-id="element-26" data-mp="7irtv0i6sx49">
                  <LinkedinIcon className="w-6 h-6 mr-3" data-id="element-27" data-mp="l9n8yuja4aga" />
                  LinkedIn
                </a>
                <a href="https://www.youtube.com/@Break-a-Pencil" target="_blank" rel="noopener noreferrer" className="text-xl text-brand-gray-light hover:text-brand-orange transition-colors inline-flex items-center" data-id="element-28" data-mp="3krmty0no6wb8">
                  <YoutubeIcon className="w-6 h-6 mr-3" data-id="element-29" data-mp="2hkm31g1nxxl" />
                  YouTube
                </a>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="flex items-start py-8" data-id="element-30" data-mp="1dx9alx8y550i">
            <MapPinIcon className="w-8 h-8 text-brand-orange mr-6 mt-1 flex-shrink-0" data-id="element-31" data-mp="2mviwjfytjght" />
            <div data-id="element-32" data-mp="2hx7jyxh52rvw">
              <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-33" data-mp="2hxpqqo1fgoi2">
                Location
              </h2>
              <p className="text-xl text-brand-gray-light" data-id="element-34" data-mp="2vxics620egjp">
                Seattle, Washington. Working with teams everywhere.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}